import _export from '../internals/export.js';

var $ = _export; // `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan

$({
  target: 'Number',
  stat: true
}, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});
